<template>
  <div class="container main-header">
    <div class="icon">
      <el-image
        :src="icon"
        style="width: 1.8rem; height: 1.8rem"
        fit="fit"
      ></el-image>
      <span>庐鸣数据助手</span>
    </div>
    <div class="func" v-if="isLoggedIn">
      <el-badge class="badge" is-dot v-for="item in func_icon_list" :key="item">
        <i :class="item"></i>
      </el-badge>
      <el-divider direction="vertical"></el-divider>
      <el-avatar size="small" :src="userAvatar"></el-avatar>
      <el-dropdown @command="handleCommand">
        <span class="user_name">
          {{ userName
          }}<i
            class="el-icon-arrow-down el-icon--right"
            style="font-size: 10px"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人中心</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="func" v-else>
      <el-button type="text" @click="handleLogin">登录</el-button>
      <el-button type="text" @click="handleRegister">注册</el-button>
    </div>
  </div>
</template>

<script>
import icon from "../assets/icon.png";
import { mapActions, mapGetters } from "vuex";
import { LOGIN_PATH } from "../utilis/enum";

export default {
  name: "HeaderComponent",
  data() {
    return {
      icon,
      func_icon_list: ["el-icon-search", "el-icon-bell", "el-icon-alarm-clock"],
      defaultAvatar:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
    };
  },
  computed: {
    ...mapGetters("user", ["userName", "isLoggedIn"]),
    userAvatar() {
      return this.$store.getters["user/userAvatar"] || this.defaultAvatar;
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),

    handleCommand(command) {
      switch (command) {
        case "profile":
          this.$router.push("/profile");
          break;
        case "settings":
          this.$router.push("/settings");
          break;
        case "logout":
          this.handleLogout();
          break;
      }
    },

    async handleLogout() {
      try {
        await this.$confirm("确定要退出登录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        await this.logout();

        this.$message.success("退出登录成功");
      } catch (error) {
        if (error !== "cancel") {
          console.error("退出登录失败:", error);
        }
      }
    },

    handleLogin() {
      this.$router.push(LOGIN_PATH);
    },

    handleRegister() {
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index.scss";

.main-header {
  padding: 0 $main_padding;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;

  .icon {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    span {
      height: 1.8rem;
      line-height: 1.8rem;
      font-size: 1rem;
      font-weight: bolder;
      color: $main_theme_color;
    }
  }

  .func {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .badge {
      margin-left: 40px;

      i {
        font-size: 1.5rem;
      }
    }

    .el-divider--vertical {
      margin: 0 20px;
    }

    .el-dropdown {
      margin-left: 10px;
    }

    .el-dropdown {
      .user_name {
        color: $main_font_color;
      }
    }
  }
}
</style>
